import React from "react";
import { makeStyles } from "tss-react/mui";
import { IAttemptListItemResponseForWorkOrder, IStep } from "@miplatform/types";
import { EmptyMessageView } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { WorkOrderAttemptStepDisplay } from "../WorkOrderAttemptStepDisplay";

export const WorkOrderDrawerStepsTab = ({
  attempt,
  handleClose,
  getAttempt,
  steps = [],
}: WorkOrderDrawerStepsTabProps): React.ReactNode => {
  const { classes } = useStyles();
  return (
    <Box className={classes.stepContent}>
      {steps.map((step) => (
        <WorkOrderAttemptStepDisplay
          key={step.id}
          step={step}
          attempt={attempt}
          handleClose={handleClose}
          getAttempt={getAttempt}
        />
      ))}
      {steps.length === 0 && (
        <EmptyMessageView
          title="No Steps Required"
          subtitle="To complete the work order, click the complete button"
        />
      )}
    </Box>
  );
};

interface WorkOrderDrawerStepsTabProps {
  attempt: IAttemptListItemResponseForWorkOrder;
  steps: IStep[];
  handleClose: () => void;
  getAttempt: () => Promise<void> | void;
}

const useStyles = makeStyles()((theme) => ({
  stepContent: {
    borderRadius: theme.spacing(1),
    display: "flex",
    flexGrow: 1,
    overflow: "auto",
    flexDirection: "column",
  },
}));
